import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=21ee7754&scoped=true&"
import script from "./userDetails.vue?vue&type=script&lang=js&"
export * from "./userDetails.vue?vue&type=script&lang=js&"
import style0 from "./userDetails.vue?vue&type=style&index=0&id=21ee7754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee7754",
  null
  
)

export default component.exports